import React from 'react';
import { PillButton } from 'library/ui';
import { ButtonContainer } from '../components/Containers';

const MainButtons = ({
    onWelcomeBackClick,
    onBanClick,
}: {
    onWelcomeBackClick: () => void;
    onBanClick: () => void;
}) => (
    <ButtonContainer>
        <PillButton variant="secondary" onClick={onWelcomeBackClick}>
            {`No, they're welcome back!`}
        </PillButton>
        <PillButton onClick={onBanClick}>Yes, please block</PillButton>
    </ButtonContainer>
);

export default MainButtons;
